import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-arrow-thin-left-top",
  "use": "icon-si-glyph-arrow-thin-left-top-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-arrow-thin-left-top\" id=\"icon-si-glyph-arrow-thin-left-top\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>1179</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M9.885,0.00600000002 C10.458,0.00400000002 10.96,0.409 10.958,0.98 C10.958,1.548 10.451,1.922 9.879,1.924 L4.525,1.932 L16.718,14.244 C17.082,14.605 17.074,15.2 16.7,15.571 C16.327,15.942 15.731,15.95 15.366,15.589 L2.926,3.389 L2.915,8.958 C2.914,9.528 2.534,9.991 1.963,9.992 C1.678,9.994 1.065,9.613 1.065,8.965 L1.082,0.022 L9.885,0.00600000002 L9.885,0.00600000002 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-arrow-thin-left-top.svg
// module id = D31q
// module chunks = 62